import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { AccountTabs } from '../components/AccountTabs';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: Index,
});

function Index() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1>Your Account</h1>
          <p>
            Manage your account details and settings. Click the buttons to
            select an action, like "Change Your Password" to reset your
            password.
          </p>
          <AccountTabs />
        </Pane>
      </div>
    </>
  );
}
